<template>
  <div id="coupons">
    <div class="lv4Text" align="right" style="padding:10px 0">
      <router-link to="/help/4" class="lv4Text">
        <i class="far fa-question-circle fa-lg" style="margin-right:5px"></i>优惠券使用说明
      </router-link>
    </div>
    <el-tabs type="border-card">
      <el-tab-pane label="未使用">
        <div class="box" v-if="total1>0">
          <el-row :gutter="40">
            <el-col :span="12" class="coupon-item" v-for="(item,index) of data1" :key="index">
              <div>
                <el-row>
                  <el-col :span="6">
                    <div class="c-left">
                      <div class="n0">&yen;{{item.money}}</div>
                      <div v-if="item.sill>0" class="n1">满{{item.sill}}可用</div>
                      <div v-else class="n2">无门槛</div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="c-mid">
                      <div class="lv1Text n3">{{item.name}}</div>
                      <div class="lv3Text n4">使用平台：{{item.typeName}}</div>
                      <div
                        class="lv3Text n5"
                      >有效期至：{{dayjs.unix(item.end_date).format('YYYY-MM-DD')}}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="c-right">
                      <router-link to="/help/2_3" class="lv3Text">使用规则>></router-link>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
          <div class="pager" align="center">
            <el-pagination
              background
              hide-on-single-page
              layout="prev, pager, next"
              :total="total1"
              :page-size="12"
              @current-change="pageChange1"
            ></el-pagination>
          </div>
        </div>
        <div v-else class="empty">
          <!-- 没有优惠券， -->
          <img style="margin:0 auto" :src="serve + '/image/none/none_img2.jpg'" alt="">
          <router-link class="lv0Text" to="/user/couponCenter">去领券</router-link>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已使用">
        <div class="box" v-if="total2>0">
          <el-row :gutter="40">
            <el-col :span="12" class="coupon-item" v-for="(item,index) of data2" :key="index">
              <div>
                <el-row>
                  <el-col :span="6">
                    <div class="c-left expired">
                      <div class="n0">&yen;{{item.money}}</div>
                      <div v-if="item.sill>0" class="n1">满{{item.sill}}可用</div>
                      <div v-else class="n2">无门槛</div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="c-mid">
                      <div class="lv3Text n3">{{item.name}}</div>
                      <div class="lv3Text n4">使用平台：{{item.typeName}}</div>
                      <div class="lv3Text n5">有效期至：已使用</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="c-right">
                      <router-link to="/help/4" class="lv3Text">使用规则>></router-link>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
          <div class="pager" align="center">
            <el-pagination
              background
              hide-on-single-page
              layout="prev, pager, next"
              :total="total1"
              :page-size="12"
              @current-change="pageChange2"
            ></el-pagination>
          </div>
        </div>
        <div v-else class="empty">
           <img style="margin:0 auto" :src="serve + '/image/none/none_img2.jpg'" alt="">
          <router-link class="lv0Text" to="/user/couponCenter">去领券</router-link>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已过期">
        <div class="box" v-if="total3>0">
          <el-row :gutter="40">
            <el-col :span="12" class="coupon-item" v-for="(item,index) of data3" :key="index">
              <div>
                <el-row>
                  <el-col :span="6">
                    <div class="c-left expired">
                      <div class="n0">&yen;{{item.money}}</div>
                      <div v-if="item.sill>0" class="n1">满{{item.sill}}可用</div>
                      <div v-else class="n2">无门槛</div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="c-mid">
                      <div class="lv3Text n3">{{item.name}}</div>
                      <div class="lv3Text n4">使用平台：{{item.typeName}}</div>
                      <div class="lv3Text n5">有效期至：已过期</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="c-right">
                      <router-link to="/help/4" class="lv3Text">使用规则>></router-link>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
          <div class="pager" align="center">
            <el-pagination
            hide-on-single-page
              background
              layout="prev, pager, next"
              :total="total1"
              :page-size="12"
              @current-change="pageChange3"
            ></el-pagination>
          </div>
        </div>
        <div v-else class="empty">
         <img style="margin:0 auto" :src="serve + '/image/none/none_img2.jpg'" alt="">
          <router-link class="lv0Text" to="/user/couponCenter">去领券</router-link>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,

      data1: {},
      data2: {},
      data3: {},
      total1: 0,
      total2: 0,
      total3: 0
    };
  },
  activated() {
    this.initData();
    this.$store.state.user_location = "优惠券";
  },
  created() {
    this.initData();
  },
  methods: {
    //
    pageChange1(v) {
      this.axios
        .get(this.serve + "/exchange/my_coupons", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: v,
            status: 1
          }
        })
        .then(res => {
          if (res.data.data1) {
            this.data1 = res.data.data.results;
            this.total1 = res.data.data.total;
          }
        });
    },
    pageChange2(v) {
      this.axios
        .get(this.serve + "/exchange/my_coupons", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: v,
            status: 2
          }
        })
        .then(res => {
          this.data1 = res.data.data.results;
          this.total1 = res.data.data.total;
        });
    },
    pageChange3(v) {
      this.axios
        .get(this.serve + "/exchange/my_coupons", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: v,
            status: 3
          }
        })
        .then(res => {
          this.data1 = res.data.data.results;
          this.total1 = res.data.data.total;
        });
    },
    initData() {
      this.axios
        .get(this.serve + "/exchange/my_coupons", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: 1,
            status: 1
          }
        })
        .then(res => {
          if (res.data.data) {
            this.data1 = res.data.data.results;
            this.total1 = res.data.data.total;
          }
        });

      this.axios
        .get(this.serve + "/exchange/my_coupons", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: 1,
            status: 2
          }
        })
        .then(res => {
          if (res.data.data) {
            this.data2 = res.data.data.results;
            this.total2 = res.data.data.total;
          }
        });

      this.axios
        .get(this.serve + "/exchange/my_coupons", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: 1,
            status: 3
          }
        })
        .then(res => {
          if (res.data.data) {
            this.data3 = res.data.data.results;
            this.total3 = res.data.data.total;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#coupons {
  margin-top: -38px;
  .empty {
    padding: 50px 0;
  }
  .el-tabs__content {
    min-height: 560px;
  }
  .box {
    .expired.c-left {
      background-color: #ccc;
    }
    padding: 10px;
    .c-mid .el-button {
      border: 0;
      padding: 0;
    }
    .c-left::before {
      content: " ";
      width: 0;
      height: 100%;
      position: absolute;
      top: 0;
      border-right: 8px dotted #fff;
      left: -4px;
    }
    .c-mid {
      border: 1px solid #ddd;
      padding-top: 30px;
      padding-left: 20px;
      line-height: 1.5em;
      border-right: 3px dotted #ddd;
      padding-bottom: 6px;
      border-left: 0;
    }
    .n4,
    .n5 {
      font-size: 12px;
    }
    .n0 {
      font-weight: bold;
      font-size: 18px;
    }
    .c-left {
      height: 70px;
      line-height: 35px;
      padding-top: 20px;
      padding-bottom: 10px;
      background-color: #e2211c;
      color: #fff;
      text-align: center;
    }
    .c-right {
      text-align: center;
      line-height: 98.4px;
      padding-right: 20px;
      border: 1px solid #ddd;
      border-left: 0;
    }
    .c-right:hover {
      text-decoration: underline;
    }
    .coupon-item {
      margin-bottom: 20px;
      background-color: #fff;
    }
  }
}
</style>